import accessStore from '../../../services/locations/AccessStore'

(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.locations.locationsManagerService', []).service('locationsManagerService', LocationsManagerService);

  LocationsManagerService.$inject = ['$http','cacheService', "$q"];
  function LocationsManagerService($http, cacheService, $q) {
    this.http_ = $http;
    this.cs_ = cacheService;
    this.q_ = $q;
  }

  LocationsManagerService.prototype.listLocations = function (accountId, query, locationSummary, includeChildAccounts) {
    return this.http_.get('/v5/locations', {params:{accountId:accountId, locationQuery: query, locationSummary: locationSummary, includeChildAccounts: includeChildAccounts}});
  };

  LocationsManagerService.prototype.getLocationNotificationSettings = function (accountId, locationSearchQuery, includeDeactivatedLocations, {limit, offset, sortField, sortOrder}) {
    if(accountId == 'all') { accountId = undefined; }
    var params = {accountId, locationQuery: locationSearchQuery || null, limit, offset, sortField, sortOrder, includeDeactivatedLocations};
    return this.http_.get('/v5/notificationSettings', {params});
  };

  LocationsManagerService.prototype.deactivateLocations = function (locationIds) {
      return this.http_.delete('/v5/locations', { params: { locationId: locationIds.join(',')} });
  };

  LocationsManagerService.prototype.activateLocations = function (locationIds) {
      return this.http_.put('/v5/locations/restore', { locationIds: locationIds.map(id => parseInt(id)) });
  };

  LocationsManagerService.prototype.updateNotificationSettings = function (notificationChanges) {
    return this.http_.post('/notificationSettings/update', {notificationUpdates: notificationChanges})
  };

  LocationsManagerService.prototype.refreshLocation = function (locationId) {
    return this.http_.post('/admin/location/' + locationId + '/refresh', {});
  };

  LocationsManagerService.prototype.exportLocations = function (accountId, locationSearchQuery, includeDeletedLocations) {
    var params = {accountId: accountId};

    if(locationSearchQuery){
      params.locationQuery = locationSearchQuery;
    }
    if(includeDeletedLocations) params.includeDeletedLocations = true;
    return this.http_.get('/v5/export/locations', {params: params});
  };

  LocationsManagerService.prototype.addLocation = function (locationReq) {
    return this.http_.post('/v5/locations', locationReq).then(x => {
      accessStore.invalidate()
      return x
    });
  }

  LocationsManagerService.prototype.updateLocation = function (locationReq) {
    return this.http_.put('/v5/locations/' +locationReq.id, locationReq).then(x => {
      accessStore.invalidate()
      return x
    });
  }

  LocationsManagerService.prototype.loadLocation = function (locationId) {
    return this.http_.get('/v5/locations/' + locationId);
  }

  LocationsManagerService.prototype.syncAndLoadLocation = function (locationId) {
    return this.http_.get('/v5/locations/syncAndGet/' + locationId);
  }

  LocationsManagerService.prototype.addCompetitorLocation = function (locationId, competitorReq) {
    return this.http_.post('/v5/locations/' + locationId + '/competitors', competitorReq)
  }

  LocationsManagerService.prototype.updateCompetitorLocation= function (locationId, competitorId, competitorReq) {
    return this.http_.put('/v5/locations/' + locationId + '/competitors/' + competitorId, competitorReq)
  }

  LocationsManagerService.prototype.loadCompetitorLocation = function (locationId, competitorId) {
    return this.http_.get('/v5/locations/' + locationId + '/competitors/' + competitorId)
  }

  LocationsManagerService.prototype.removeCompetitorLocation = function (locationId, competitorId) {
    return this.http_.delete('/v5/locations/' + locationId + '/competitors/' + competitorId)
  }

  LocationsManagerService.prototype.searchPlaces = function (params) {
    return this.http_.get('/v5/instantAudit/places', {params})
  }

})();
